/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import {
  getConfig,
  IThemeConfig,
  PageDataContainer,
  PageLink,
  useTheme,
} from '../../../_start/layout/core';
import { ClientManagementPage } from './ClientManagementPage';
import { clientManagementSubmenu } from './ClientManagementPageData';

const customerManagementBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isActive: false,
  },
  {
    title: 'Client Management',
    path: '/client-management',
    isActive: false,
  },
];

const defaultPageConfig = getConfig();
const customerManagementPageConfig: Partial<IThemeConfig> = {
  sidebar: {
    ...defaultPageConfig.sidebar,
    display: false,
    content: 'user',
    bgColor: 'bg-info',
  },
};

export const ClientManagementWrapper = () => {
  const { setTheme } = useTheme();

  // Refresh UI after config updates
  useEffect(() => {
    setTheme(customerManagementPageConfig);
    return () => {
      setTheme(defaultPageConfig);
    };
  }, []);

  return (
    <>
      <PageDataContainer
        breadcrumbs={customerManagementBreadCrumbs}
        submenu={clientManagementSubmenu}
      />
      <ClientManagementPage />
    </>
  );
};
